<template>
  <div class="mypage-mail-change-complete-pane">
    <mypage-mail-change-complete-section />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypageMailChangeCompleteSection from '@/components/MypageMailChangeCompletePage/MypageMailChangeCompletePane/MypageMailChangeCompleteSection.vue'

/**
 * マイページ: メールアドレス変更変更完了 コンテンツペイン
 */
export default defineComponent({
  name: 'MypageMailChangeCompletePane',
  components: {
    MypageMailChangeCompleteSection,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-mail-change-complete-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding-bottom: 80px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
